"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shibuya = void 0;

/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/no-namespace
var Shibuya;
exports.Shibuya = Shibuya;

(function (_Shibuya) {
  var EventName;

  (function (EventName) {
    EventName["SKU_VIEWED"] = "SKU Viewed";
    EventName["SHOPPING_FINISHED"] = "Shopping Finished";
  })(EventName || (EventName = {}));

  _Shibuya.EventName = EventName;
})(Shibuya || (exports.Shibuya = Shibuya = {}));